<template>
  <TableGroup
    v-if="currentItem.is_surcharge_fot"
    table-title="Доплаты ФОТ"
    modal-title="Создать доплату ФОТ"
    namespaced="pto/project/estimate/fotProduction"
    :rights-all="$store.getters.rightsPtoAll"
    :init-filter="initFilter"
    namespaced-handbook="handbook/pto"
    :handbooks="['FotSurcharges']"
  >
    <template v-slot:modalForm="props">
      <FormPtoProjectFotProduction
        :is-sending="props.isSendingRequest"
        :date="currentItem.start_date"
        @request="props.createSubmit"
        @cancel="props.closeModal"
      />
    </template>
  </TableGroup>
</template>

<script>
import TableGroup from '@/components/page/TableGroup'
import { mapGetters } from 'vuex'
import FormPtoProjectFotProduction from '@/components/pto/form/FormPtoProjectFotProduction'

export default {
  name: 'PtoProjectWorkSignUpdateOwn',
  components: {
    FormPtoProjectFotProduction,
    TableGroup
  },
  computed: {
    ...mapGetters('pto/project/estimate/workSign', {
      currentItem: 'getCurrentItem'
    }),
    initFilter () {
      return {
        workSignId: this.$route.params.id
      }
    }
  }
}
</script>
